import React from 'react';
import { BrowserRouter as Router, Switch, Route, Link} from "react-router-dom";
import {TransitionGroup, CSSTransition} from 'react-transition-group';

export default class Aside extends React.Component{
	constructor(props){
		super(props);
		this.state={};
		this.hideMenu=this.hideMenu.bind(this);
	}
	hideMenu(){
		const a = document.querySelector('aside');
		if(a.classList.contains('active')){
			a.classList.remove('active');
		}
	}
	render(){
		return(
			<aside>
				<div className='logo'>
					Jester&Niko
					<h1>tattoo salon</h1>
				</div>
				<nav>
					<ul>
						<li><Link onClick={this.hideMenu} to='/'>home</Link></li>
						<li><Link onClick={this.hideMenu} to='/about'>about us</Link></li>
						<li><Link onClick={this.hideMenu} to='/works'>our works</Link></li>
						<li><Link onClick={this.hideMenu} to='/contacts'>our address</Link></li>
					</ul>
				</nav>
				<div className='social'>
					<ul>
						<li>
							<a target='_blank' href='https://www.facebook.com/profile.php?id=100010152754764'>
							<img src={require('../../img/facebook.png')}/>@niko&jecster</a>
						</li>
						<li>
							<a target='_blank' href='https://www.instagram.com/mike.hayerson/'>
							<img src={require('../../img/instagram.png')}/>mike.hayerson</a>
						</li>
						<li><a target='_blank' href=''><img src={require('../../img/telegram.png')}/>@niko&jecster</a></li>
						<li><img src={require('../../img/phone.png')}/>+38(097)32-13-949</li>
						<li><img src={require('../../img/phone.png')}/>+38(073)04-43-847</li>
					</ul>
				</div>
				<a className='we' target="_blank" href='https://www.facebook.com/bringmetheaugust'>
					made by<br/>
					BringMeTheAugust
				</a>
			</aside>
		)
	}
}